module.exports = __webpack_public_path__ + "img/mo-foto-hoofd-klein.ca61baed.jpg";